import React from 'react'
import PropTypes from 'prop-types'
import styles from 'components/Onboarding/FormStyles.module.scss'
import {
  TextareaFormField,
} from 'belle-js'

const PlanYearDetails = (props) => {
  const { data } = props
  return (
    <div className={styles.indentedConditionalWrapper}>
      <div className={styles.inputWrapper}>
        <TextareaFormField
          name="sepPlanYearElectionsCustomPeriod"
          className={styles.detailsTextarea}
          placeholder="Specify details"
          maxLength={35}
          value={data.sepPlanYearElectionsCustomPeriod || ''}
          testId="sepPlanYearElectionsCustomPeriod" />
      </div>
    </div>
  )
}

PlanYearDetails.propTypes = {
  data: PropTypes.object.isRequired
}

export default PlanYearDetails



// WEBPACK FOOTER //
// ./src/components/Onboarding/AdditionalDetails/PlanYearDetails/PlanYearDetails.jsx